// Ultimate Card Game (UCG) - Bot AI sampling helpers
//
// Random variates drawn from the bot's own rng (never Math.random), shared by
// the strategist (Thompson sampling) and the humanizer (latencies, rhythm).

export function gaussian(rng) {
  const u = Math.max(1e-12, rng.next());
  const v = rng.next();
  return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
}

// Gamma(shape, 1) by Marsaglia-Tsang; accurate for shape >= 1.
export function gamma(shape, rng) {
  const d = shape - 1 / 3;
  const c = 1 / Math.sqrt(9 * d);
  for (let i = 0; i < 100; i++) {
    const x = gaussian(rng);
    const v = (1 + c * x) ** 3;
    if (v <= 0) continue;
    const u = rng.next();
    if (Math.log(Math.max(1e-12, u)) < 0.5 * x * x + d - d * v + d * Math.log(v)) return d * v;
  }
  return d;
}

// Beta(a, b): two Gamma draws (a, b >= 1).
export function sampleBeta(a, b, rng) {
  const x = gamma(Math.max(1, a), rng);
  const y = gamma(Math.max(1, b), rng);
  return x / (x + y);
}

// Log-normal with the given median (sigma = spread of the logarithm).
export function lognormal(median, sigma, rng) {
  return median * Math.exp(sigma * gaussian(rng));
}
